/** RFC 4180 CSV field escaping. Wraps the value in double-quotes and doubles
 * any internal double-quotes when the value contains a comma, double-quote,
 * carriage return, or newline. */
export function csvEscapeField(v: string | number | null | undefined): string {
  const s = String(v ?? "");
  return /[,"\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
